import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import DownloadSection from '../../../../../DownloadSection/DownloadSection';
import { getPoSSselector } from '../../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import '../Tabular/FacilityRatingsTabular.css'
import CustomDatePickerMMYYYYonly from '../../../../../../../DatePicker/Month/CustomDatePickerMMYYYYonly';
import CommonChart from '../../../../../Dashboard/DefaultDashboard/Graphs/CommonChart';
import NoData from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/Nodata';
import { createChartsProps, donutType } from '../../../../../../../../Assests/DashboardUtility';
import { facilityRatingColumnGraph } from '../../../../../../../../Assests/GraphUtilities';
import moment from 'moment';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
import Loader from '../../../../../../../Loader/Loader';
import DatePickerSS from '../../../../../../../DatePickerSS/DatePickerSS';
import CustomTimeSelector from '../../../../../../../Common/CustomTimeSelector/CustomTimeSelector';
import { formatDate_MM_DD_YYYY } from '../../../../../../../../Assests/Utility';

const FacilityRatingsGraphical = (props) => {
    const { themeSelected = 'light-mode', view, startDate, setStartDate, endDate, setEndDate, isError, startTimeState, setStartTimeState, endTimeState, setEndTimeState } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pOSS = useSelector(getPoSSselector);
    const { facilityRatingsAllData } = pOSS;
    const userObj = useSelector(getUserSelector);
    const { selectedWarehouse, userType } = userObj;
    const [currentTable, setCurrentTable] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showGraph, setShowGraph] = useState(false)
    const [facilityRatingsColumnData, setFacilityRatingsColumnData] = useState({})
    const [showStartDate, setShowStartDate] = useState(false);
    const [showEndDate, setShowEndDate] = useState(false);
    const [maxEndDate, setMaxEndDate] = useState(new Date());

    useEffect(() => {
        // setStartDate(null);
        // setEndDate(null);
        // setStartTimeState(null);
        // setEndTimeState(null);

        dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
        setIsLoading(false);
        setShowGraph(false)
        return () => {
            dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
        }
    }, [])

    useEffect(() => {
        if (!isError && startDate && endDate && startTimeState && endTimeState) {
            fetchFacilityRatings()
        }
    }, [startDate, endDate, startTimeState, endTimeState, isError])

    useEffect(() => {
        if (!_.isEmpty(facilityRatingsColumnData)) {
            setIsLoading(false)
            setShowGraph(true)
        } else {
            setShowGraph(false)
        }
    }, [facilityRatingsColumnData])

    useEffect(() => {
        if (_.upperCase(facilityRatingsAllData?.status) === 'SUCCESS') {
            setIsLoading(false)
            setShowGraph(false)
            if (!_.isEmpty(facilityRatingsAllData?.data) && _.size(facilityRatingsAllData?.data?.counts)) {
                let dataGreat = [];
                let dataGood = [];
                let dataOkay = [];
                const categories = []

                Array.from(facilityRatingsAllData?.data?.counts).forEach(el => {
                    categories.push(el.monthName);
                    dataGreat.push(Math.round(el.percentages.Great));
                    dataGood.push(Math.round(el.percentages.Good));
                    dataOkay.push(Math.round(el.percentages.Okay));

                })

                const series = [{ name: 'Great', data: dataGreat }, { name: 'Good', data: dataGood }, { name: 'Okay', data: dataOkay }]
                const facilityRatingsGraphPayload = createChartsProps({ series: series, categories: categories }, donutType.faciltyRatingsColumnGraph, themeSelected, facilityRatingColumnGraph)
                setFacilityRatingsColumnData({ ...facilityRatingsGraphPayload })
            }
        } else if (_.upperCase(facilityRatingsAllData?.status) === 'FAIL') {
            setIsLoading(false)
            setShowGraph(false)
            dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
        }
        else {

            setShowGraph(false)
        }

    }, [facilityRatingsAllData])


    const fetchFacilityRatings = () => {
        if (userType === 'USER') {
            setIsLoading(true);
            const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
            const params = {
                "warehouse_id": selectedWarehouse.ID,
                //    /"startDate": moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                // "endDate": moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "startDate": combineDateAndTime(startDate, startTimeState, true),
                "endDate": combineDateAndTime(endDate, endTimeState, true),
                "currentPage": 1,
                "itemsPerPage": facilityRatingsAllData?.data?.itemsPerPage || 100,
                "rating": null,
                "type": view
            }
            dispatch({ type: sagaActions.UPDATE_FACILITY_RATINGS, payload: params });
        } else if (userType === 'SUPERADMIN') {
            // console.log("🚀 SUPERADMIN: See what will happen in this case")
        } else {
            // console.log(userType, " 🚀: This report is not accessible")
        }
    }
    const combineDateAndTime = (date, time, addTimeZone) => {
        if (!date || !time) return null;

        // Extract date and time parts separately
        const datePart = moment(date).format('YYYY-MM-DD');

        // Convert to UTC and format
        if (addTimeZone) {
            return `${datePart}T${time}:00Z`;
        }
        return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
    };

    const handleTimeChange = (value, name) => {
        if (name === 'startTime') {
            setStartTimeState(value);
        } else if (name === 'endTime') {
            setEndTimeState(value);
        }
    };

    const handleTimeError = (fieldName) => {
        // Placeholder for handling field-level validation if needed
        if (!fieldName) return;
    };
    /**
* Function to handle startdate change
* @param {*} date
*/
    // const handleStartDate = (date) => {
    //     let threeMonthslater = new Date(date);
    //     threeMonthslater.setMonth(date.getMonth() + 3);
    //     if (threeMonthslater < endDate) {
    //         setEndDate(null);
    //     }
    //     setStartDate(date);
    //     getMaxEndDate(date);
    // };

     const handleStartDate = (date) => {
            let shouldClearEndDate = false;
    
            // Case 1: startDate > endDate
            if (endDate && date > endDate) {
                shouldClearEndDate = true;
            }
    
            // Case 2: difference between start and end > 3 months
            if (endDate && !shouldClearEndDate) {
                const diffInMonths = moment(endDate).diff(moment(date), 'months', true); // fractional months
                if (diffInMonths > 3) {
                    shouldClearEndDate = true;
                }
            }
    
            if (shouldClearEndDate) {
                setEndDate(null);
            }
    
            setStartDate(date);
            getMaxEndDate(date);
        };
    
        
    /**
     * Function to return max end date
     */
    const getMaxEndDate = (startDate) => {
        let currentDate = new Date();
        let threeMonthslater = new Date(startDate);
        threeMonthslater.setMonth(startDate.getMonth() + 3);
        threeMonthslater.setDate(threeMonthslater.getDate() - 1);
        if (currentDate <= threeMonthslater) {
            setMaxEndDate(currentDate);
        } else {
            setMaxEndDate(threeMonthslater);
        }
    };


    const displayLoader = (themeSelected, height, count) => {
        return (
            <>
                <div className='navText d-flex justify-content-center color-highlight'>
                    {AppConstant.reports.facilityRatings.graphLoaderText}
                </div>
                <Loader height={200} count={count || 1} highlightColor={themeSelected === 'dark-mode' ? '#151515' : ''}
                    baseColor={themeSelected === 'dark-mode' ? '#575757'
                        : ''}
                />
            </>
        )
    }

    return (
        <div>
            <div className='d-flex justify-content-between my-2 mx-3'>
                <div className='fw-bold'>{'Facility Ratings'}</div>
                <div className='d-flex justify-content-end align-items-end gap-3'>

                    <div className="d-flex appt-report-header gap-3 align-items-center">
                        <div className="pos-rel">
                            <div className="d-flex flex-column align-items-start">
                                <label className="boldText m-2 f-14">
                                    <i className="fa-regular fa-calendar"></i> Start Date{" "}
                                </label>
                                <button
                                    className={"datePickerBtn h-100 w-100"}
                                    onClick={() => setShowStartDate(!showStartDate)}
                                    disabled={false}
                                >
                                    <span className="btn-title">
                                        {startDate
                                            ? formatDate_MM_DD_YYYY(startDate)
                                            : "Start Date"}
                                    </span>
                                    <i
                                        className="fa-regular fa-calendar"
                                        style={{ marginInline: "9px" }}
                                    ></i>
                                </button>
                                {showStartDate && (
                                    <div className="appt-summary-ss-datePicker csce-ss-datePicker">
                                        <DatePickerSS
                                            maxDate={new Date()}
                                            setSelectedDate={handleStartDate}
                                            selectedDate={startDate}
                                            closeCalendar={() => {
                                                setShowStartDate(!showStartDate);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="pos-rel">
                            <div className="d-flex flex-column align-items-start">
                                <label className="boldText m-2 f-14">
                                    <i className="fa-regular fa-calendar"></i> End Date{" "}
                                </label>

                                <button
                                    className={"datePickerBtn h-100 w-100"}
                                    onClick={() => setShowEndDate(!showEndDate)}
                                    disabled={false}
                                >
                                    <span className="btn-title">
                                        {endDate
                                            ? formatDate_MM_DD_YYYY(endDate)
                                            : "End Date"}
                                    </span>
                                    <i
                                        className="fa-regular fa-calendar"
                                        style={{ marginInline: "9px" }}
                                    ></i>
                                </button>
                                {showEndDate && (
                                    <div className="appt-summary-ss-datePicker">
                                        <DatePickerSS
                                            setSelectedDate={setEndDate}
                                            minDate={new Date(startDate)}
                                            maxDate={maxEndDate}
                                            selectedDate={endDate}
                                            closeCalendar={() => {
                                                setShowEndDate(!showEndDate);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='d-flex flex-column align-items-start' style={{ width: '300px' }}>
                        <label className="boldText m-0 f-14">
                            <i className="fa-regular fa-clock"></i> Start Time{" "}
                        </label>
                        <CustomTimeSelector
                            name="startTime"
                            title="Start Time"
                            value={startTimeState}
                            onChange={handleTimeChange}
                            handleErrors={handleTimeError}
                        />
                    </div>

                    <div className='d-flex flex-column align-items-start' style={{ width: '300px' }}>
                        <label className="boldText m-0 f-14">
                            <i className="fa-regular fa-clock"></i> End Time{" "}
                        </label>
                        <CustomTimeSelector
                            name="endTime"
                            title="End Time"
                            value={endTimeState}
                            onChange={handleTimeChange}
                            handleErrors={handleTimeError}
                        />
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center m-4'>
                {
                    !isLoading ?
                        showGraph ?
                            <div id='bar-chart'><div className="responsive-chart-bar"> <CommonChart data={facilityRatingsColumnData} /> </div></div>
                            : <NoData themeSelected={themeSelected} />
                        : <div className='w-50'>{displayLoader(themeSelected)}</div>

                }
            </div>
        </div>
    );
}

export default FacilityRatingsGraphical;